<template>
  <b-form-group
    :label="label"
    :label-for="id"
    :invalid-feedback="getFieldError(field)"
    :state="!fieldHasError(field)"
    :aria-required="required"
  >
    <Editor
      :disabled="isPosting"
      :tinymce-script-src="scriptSrc"
      v-model="inputValue"
      :init="init"
      modelEvents="change input keyup undo redo"
    />
  </b-form-group>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import FormGroupWithValidationMixin from "@/components/FormGroups/FormGroupWithValidationMixin";

// Pasted inline styles are reduced to these (5.x paste_retain_style_properties, removed in 6.x).
const PASTE_RETAINED_STYLES = ["text-decoration"];

const keepRetainedStyles = (_editor, args) => {
  args.node.querySelectorAll("[style]").forEach(el => {
    const kept = PASTE_RETAINED_STYLES.map(name => [
      name,
      el.style.getPropertyValue(name)
    ]).filter(([, value]) => value);
    el.removeAttribute("style");
    kept.forEach(([name, value]) => el.style.setProperty(name, value));
  });
};

export default {
  mixins: [FormGroupWithValidationMixin],
  components: {
    Editor
  },
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      // Self-hosted copy (vue.config.js), versioned path: nginx caches *.js forever.
      scriptSrc: `${process.env.BASE_URL}tinymce/${process.env.VUE_APP_TINYMCE_VERSION}/tinymce.min.js`,
      init: {
        height: 300,
        toolbar: "undo redo | styles | bold italic | numlist bullist",
        plugins: "lists advlist",
        convert_fonts_to_spans: true,
        paste_data_images: false,
        paste_postprocess: keepRetainedStyles,
        entity_encoding: "raw",
        menubar: false,
        promotion: false,
        valid_elements:
          "h1,h2,h3,h4,h5,h6,span,p,strong,b,i,ul,li,ol,u,br,strike,span[style],em",
        invalid_styles: "font-weight",
        setup: editor => {
          // tinymce-vue 3.x calls editor.setMode on `disabled` change; 6.x only has editor.mode.set.
          if (!editor.setMode) {
            editor.setMode = mode => editor.mode.set(mode);
          }
        }
      }
    };
  }
};
</script>
